// import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts"
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { PhaseData } from '../Step2';
import { PieChart } from 'react-minimal-pie-chart';
const ProjectStageGraph = ({ hoveredValue }) => {
    var _a;
    const { watch } = useFormContext();
    const selectedValue = watch("phase");
    const displayOption = (_a = hoveredValue !== null && hoveredValue !== void 0 ? hoveredValue : selectedValue) !== null && _a !== void 0 ? _a : null;
    const phaseOption = PhaseData.find((option) => option.name === displayOption);
    const graphData = PhaseData.map((data, idx) => {
        return {
            title: data.name,
            color: (phaseOption && PhaseData[idx] == phaseOption) ? data.colour : "#BEC4C1",
            value: 1
        };
    });
    return (React.createElement("div", { className: "pie-container" },
        React.createElement(PieChart, { lineWidth: 30, data: graphData, startAngle: -67.5, radius: 48, segmentsStyle: (idx) => {
                return {
                    filter: ((phaseOption && PhaseData[idx] == phaseOption) || !phaseOption || phaseOption === null)
                        ? "none"
                        : "blur(2px)",
                    transition: "filter .1s ease-in-out",
                };
            } }),
        React.createElement("div", { className: "pie-text-container" },
            React.createElement("div", { className: "pie-text" },
                React.createElement("h2", null, phaseOption === null || phaseOption === void 0 ? void 0 : phaseOption.id),
                React.createElement("h2", null, (phaseOption === null || phaseOption === void 0 ? void 0 : phaseOption.name) || (React.createElement(React.Fragment, null,
                    "RIBA",
                    React.createElement("br", null),
                    "Plan of work"))),
                React.createElement("p", null, (phaseOption === null || phaseOption === void 0 ? void 0 : phaseOption.description) || "Initial stage to access project viability, costs, and requirements before proceeding.")))));
};
export default ProjectStageGraph;
